module.exports = __webpack_public_path__ + "assets/logo-mobile@2x.png?547aa91c8ee3619193308b30293a6497";